<script setup></script>
<template>
  <div class="w-100 my-4">
    <slot />
  </div>
</template>
